import { css, jsx} from '@emotion/react'
import { ButtonBase } from '@mui/material';
 /** @jsxImportSource @emotion/react */
import React, { useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Space, Table } from 'antd';
import { Pagination } from 'antd';
import Button from '@mui/material/Button';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';

import { pageContext, useLang } from '../../context';
import Alert from '../alert'
import axios from '../apiClient';



export default function List() {
  const {currentPages,changePages} = useContext(pageContext)
  const [members,setMembers] = useState([]);
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [totalMembers, setTotalMembers] = useState();
  const [searchName,setSearchName] = useState('');
  const mounted = useRef(false)
  const {text} = useLang();

  const navigate = useNavigate()
  const [page,setPage] = useState(currentPages.memberManagementListPage);
  const columns = [
    {
      title: text['Username'],
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: text['Full Name'],
      dataIndex: 'full_name',
      key: 'full_name',
    },
    {
      title: text['Phone No.'],
      key: 'phone_number',
      dataIndex: 'phone_number',
    },
    {
      title: text['Action'],
      // fixed: 'right',
      // width: "500px",
      title: <div style={{ textAlign: 'center' }}>Action</div>,
      render: (data) => {
        const {id,is_locked,is_suspended} = data;
        const negativeColor = "#EA5455"
        const closeColor = `${is_locked == 'true' ? `${negativeColor}`: `#0E8388`}`
        const suspendColor = `${is_suspended == 'true' ? `${negativeColor}`: `#655DBB`}`
        const editColor = "#4E6E81"
        const viewColor = "#66347F"
        const statementsColor = "#D4AC2B"
        return (
        <Space size="middle">
          <Button onClick={()=>handleAction({action: "close",status: `${is_locked == `true` ? false : true}`,id})} css={css`color: black;border-color: ${closeColor};:hover{border-color: ${closeColor};}`} color='success' variant="outlined" startIcon={is_locked == 'true' ? <LockOpenRoundedIcon css={css`color: ${closeColor};`}/> : <LockRoundedIcon css={css`color: ${closeColor};`}/>}>
            {is_locked == 'true' ? text[`UnLock`] : text[`Lock`]}
         </Button>
         <Button onClick={()=>handleAction({action: "suspend",status: `${is_suspended == `true` ? false : true}`,id})} css={css`color: black;border-color: ${suspendColor};:hover{border-color: ${suspendColor};}`} color='success' variant="outlined" startIcon={<IndeterminateCheckBoxRoundedIcon css={css`color: ${suspendColor};`}/>}>
            {is_suspended == 'true' ? text[`UnSuspended`] : text[`Suspended`]}
         </Button>
         <Button onClick={()=>handleAction({action: "edit",data})}  css={css`color: black;border-color: ${editColor};:hover{border-color: ${editColor};}`} color='success' variant="outlined" startIcon={<EditRoundedIcon css={css`color: ${editColor};`}/>}>
            {text['Edit']}
         </Button>
         <Button onClick={()=>handleAction({action: "view",data})} css={css`color: black;border-color: ${viewColor};:hover{border-color: ${viewColor};}`} color='success' variant="outlined" startIcon={<RemoveRedEyeRoundedIcon css={css`color: ${viewColor};`}/>}>
             {text['View']}
         </Button>
         <Button onClick={()=>handleAction({action: "transactions",data})} css={css`color: black;border-color: ${statementsColor};:hover{border-color: ${statementsColor};}`} color='success' variant="outlined" startIcon={<SummarizeRoundedIcon css={css`color: ${statementsColor};`}/>}>
             {text['Transactions']}
         </Button>
        </Space>
      )},
    },
  ];
  const handleAction = (obj) =>{
    const {action} = obj;
    if(action == "view"){
      navigate('/member-management/list/memberDetail',{state: obj.data})
      return
    }
    if(action == "edit"){
      navigate('/member-management/list/editUser',{state: obj.data})
      return
    }

    if(action == "transactions"){
      console.log("obj",obj.data)
      navigate('/reports/statement',{state: {username: obj?.data?.username}})
      return
    }
    fetchData(obj)
  }

  // get data from backend when componenet is first mounted
  async function fetchData({action,status,id}) {
    setLoading(true)
    // if action is true -----------------------------------------
    if(action){
      let url;
      let data;
      let params;
      if(action == 'close'){
        params ={'uid': id,"is_locked": status}
        url = `/member/updateLockedStatus`
        data = await axios.put(`/member/updateLockedStatus`,params)
      }
      if(action == 'suspend'){
        params ={'uid': id,"is_suspended": status}
        url = `/member/updateSuspendedStatus`
      }
      data = await axios.put(url,params)
      if(data.code == 200){
        if(action == 'close') data.message = `${status == 'true' ? "Successfully locked the member" : "Successfully unlocked the member"}`
        if(action == 'suspend') data.message = `${status == 'true' ? "Successfully suspended the member" : "Successfully unsuspended the member"}`
      }
      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
    }
    //-------------------------------------------------------------------------------------

    let data = await axios.get(`/member/getAllMembers?current=${page}&pageSize=10`)

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setMembers([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setMembers(data.data.agents)
    setTotalMembers(data.data.pagination.total)
    setLoading(false)
}
  //--------------------------------------------------
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }

  const handleSearch = async (name,page) =>{
  setLoading(true)
  setSearchName(name)
  let data = await axios.get(`/member/getMemberByName?uname=${name}&current=${page}&pageSize=10`)
  setLoading(false)
  if (data.code != 200) {
      if(data.code == 404){
          setMembers([])
          return
      }
      setErrorMsg({ code: data.code, msg: data.message })
      setOpenAlert(true)
      return
  }
  setMembers(data.data.members)
  setTotalMembers(data.data.pagination.total)
  }
  
  useEffect(()=>{
    if(mounted.current){
      if(searchName != ''){
        handleSearch(searchName,page)
        return;
      }
      fetchData({})
    }
  },[page])

  useEffect(()=>{
    if(mounted.current) setPage(1)
  },[searchName])

  useEffect(()=>{
    mounted.current = true
    fetchData({})
  },[])
  const handlePageChange = (page) => {
    setPage(page)
    changePages({memberManagementListPage: page})
  }
  
  return (
    <div>
      <div>
        <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
        <div css={css`display: flex;justify-content: space-between;`}>
          <input placeholder={`${text['Search']}...`} css={css`padding: 0.6rem 0.6rem;border-radius: 0.6rem;border: 1px solid grey;outline: none;&:focus {border-color: #5e35b1;}`} onChange={(e)=>handleSearch(e.currentTarget.value,page)}/>
          <ButtonBase onClick={()=>navigate('/member-management/createUser')} component="div" css={css`background-color: #5e35b1;padding: 0 1rem;border-radius: 0.6rem;color: white;`}><AddIcon css={css`font-size: 1rem;`}/>{text["Create New Member"]}</ButtonBase>
        </div>
        <div>
          <Table loading={loading}  scroll={{x: 'min-content'}} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={members} />
          <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`}  current={page} total={totalMembers} pageSize={10} showSizeChanger={false} onChange={(page)=> handlePageChange(page)}/>
        </div>
      </div>

      
    </div>
  )
}
